import { Box, Typography } from "@mui/material";
import { roundMacros } from "@notemeal/shared-utils-macro-protocol";
import { getServingAmountsMacros } from "shared-ui/ServingAmount/utils";
import { FullServingAmountFragment } from "../../../types";

interface TotalMacrosProps {
  servingAmounts: readonly FullServingAmountFragment[];
}

export const TotalMacros = ({ servingAmounts }: TotalMacrosProps) => {
  const macros = roundMacros(getServingAmountsMacros(servingAmounts));

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography
        sx={{
          fontSize: 16,
          fontWeight: 600,
          lineHeight: "24px",
          color: "text.primary",
        }}
      >
        Total Macros
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          fontSize: 14,
          fontWeight: 400,
          lineHeight: "18px",
          color: "text.primary",
        }}
      >
        <Typography component="span" sx={{ width: 80, fontSize: "inherit", lineHeight: "inherit" }}>
          {Math.round(macros.kcal)} kcal
        </Typography>
        <Typography component="span" sx={{ width: 80, fontSize: "inherit", lineHeight: "inherit" }}>
          <Box component="span" sx={{ color: "cho.main" }}>
            CHO
          </Box>
          : {Math.round(macros.cho)}g
        </Typography>
        <Typography component="span" sx={{ width: 80, fontSize: "inherit", lineHeight: "inherit" }}>
          <Box component="span" sx={{ color: "pro.main" }}>
            PRO
          </Box>
          : {Math.round(macros.pro)}g
        </Typography>
        <Typography component="span" sx={{ width: 80, fontSize: "inherit", lineHeight: "inherit" }}>
          <Box component="span" sx={{ color: "fat.main" }}>
            FAT
          </Box>
          : {Math.round(macros.fat)}g
        </Typography>
      </Box>
    </Box>
  );
};
